import EmarPatientVitalsV1 from "../../../../components/form_builder/elements/emar_patient_vitals/EmarPatientVitalsV1.vue";

export default {
  componentName: "fb-emar-patient-vitals-v1",
  component: EmarPatientVitalsV1,
  defaultAttrs: {
    properties: {
      value: ``,
      style: {},
      label: "Emar Patient Vitals",
      description: "",
      eFormEditable: false,
      hidden: false,
      dateFilter: "currentday",
      dependentProperties: {}
    },
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value,
  },
  validate: () => {
    return [];
  },
};

